import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ErrorModalComponent } from '../../components/shared/error-modal/error-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ErrorModalService {
  constructor(private modalService: BsModalService) { }

  showErrorModal(errorMessage: string, errorTitle: string = 'Error Occurred'): BsModalRef {
    const config = {
      ignoreBackdropClick: false,
      class: "modal-dialog-centered",
      keyboard: false,
      initialState: {
        errorTitle: errorTitle,
        errorMessage: errorMessage
      }
    };
    const modalRef = this.modalService.show(ErrorModalComponent, config);
    // Set errorMessage directly on the component instance
    if (modalRef.content) {
      (modalRef.content as ErrorModalComponent).errorTitle = errorTitle;
      (modalRef.content as ErrorModalComponent).errorMessage = errorMessage;
    }
    return modalRef;
  }
}

